import {Routes, RouterModule} from '@angular/router';
import {MainLayoutComponent} from './shared/layout/app-layouts/main-layout.component';
import {ModuleWithProviders} from '@angular/core';
import {AuthGuard} from './+app-custom/guards/auth.guard';
import {UserProfileViewComponent} from './+app-custom/views/user-profile-view/user-profile-view.component';
import {AddIsbnViewComponent} from './+app-custom/views/add-isbn-view/add-isbn-view.component';
import {PublicationRegistrationViewComponent} from './+app-custom/views/publication-registration-view/publication-registration-view.component';
import {MyPublicationViewComponent} from './+app-custom/views/my-publication-view/my-publication-view.component';
import {PublicationListViewComponent} from './+app-custom/views/publication-list-view/publication-list-view.component';
import {PublicationReviewViewComponent} from './+app-custom/views/publication-review-view/publication-review-view.component';
import {GenerateReportViewComponent} from './+app-custom/views/generate-report-view/generate-report-view.component';
import {ActionHistoryListViewComponent} from './+app-custom/views/action-history-list-view/action-history-list-view.component';
import { DevComponent } from './+app-custom/components/dev/dev.component';
import {RoleGuard} from './+app-custom/guards/role.guard';
import {StatisticsViewComponent} from './+app-custom/views/statistics-view/statistics-view.component';
import {DashboardViewComponent} from './+app-custom/views/dashboard-view/dashboard-view.component';
import {FaqViewComponent} from './+app-custom/views/faq-view/faq-view.component';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
            {path: 'dev', component: DevComponent},
            {path: 'faq', component: FaqViewComponent, pathMatch: 'full'},
            {path: 'isbn', component: AddIsbnViewComponent,
                data: {pageTitle: 'addIsbnNavBar' ,roles:['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN']}, pathMatch: 'full' , canActivate: [RoleGuard]},
            {path: 'publication/registration', component: PublicationRegistrationViewComponent,
                data: {pageTitle: 'publicatioinRegister'}, pathMatch: 'full'},
            {path: 'profile', component: UserProfileViewComponent, data: {pageTitle: 'profile'}, pathMatch: 'full'},
            {path: 'user/publications', component: MyPublicationViewComponent, data: {pageTitle: 'myPublication'}, pathMatch: 'full'},
            {path: 'dashboard', component: DashboardViewComponent, data: {pageTitle: 'dashboard'}, pathMatch: 'full'},
            {path: 'publications', component: PublicationListViewComponent,
                data: {pageTitle: 'publicationList'  ,roles:['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN']}, pathMatch: 'full', canActivate: [RoleGuard]},
            {path: 'publication/:id', component: PublicationReviewViewComponent,
                data: {pageTitle: 'review'  ,roles:['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN']}, pathMatch: 'full', canActivate: [RoleGuard]},
            {path: 'report', component: GenerateReportViewComponent,
                data: {pageTitle: 'generateReport'  ,roles:['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN']}, pathMatch: 'full', canActivate: [RoleGuard]},
            {path: 'actions', component: ActionHistoryListViewComponent,
                data: {pageTitle: 'actionList' ,roles:['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN']}, pathMatch: 'full', canActivate: [RoleGuard]},
            {path: 'statistics', component: StatisticsViewComponent,
                data: {pageTitle: 'actionList' ,roles:['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN']}, pathMatch: 'full', canActivate: [RoleGuard]}
        ],
        canActivate: [AuthGuard]
    }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts